<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-broom" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Normas Técnicas</div>
      </template>

      <v-btn
        id="btn-new-normas-tecnicas"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push(`normas-tecnicas/edit`)"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        NOVAS NORMAS
      </v-btn>

      <v-text-field
        id="normas-tecnicas-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-normas-tecnicas ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />

      <general-progress-bars class="mt-11" :items="downloadProgressData" prefixText="Baixando Normas Técnicas" />

      <v-divider class="mt-10" />

      <v-data-table
        class="normas-tecnicas-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :loading="loadingItems"
        no-data-text="Nenhum registro disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :headerProps="{ sortByText: 'Ordenar Por' }"
        :footer-props="{ itemsPerPageText: 'Itens por Página' }"
        mobile-breakpoint="800"
      >
        <template v-slot:[`item.id`]="{ item }">{{ item.id }}</template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" @click="openDialogAcompanhamento(item)" v-on="on">
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">{{ item.usuario }}</template>
        <template v-slot:[`item.executed`]="{ item }">{{ item.created }}</template>
        <template v-slot:[`item.modified`]="{ item }">{{ item.modified }}</template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-normas-tecnicas"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            @click="downloadItem(item, `Normas Técnicas ${item.nome}`)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-btn
            id="action-edit-normas-tecnicas"
            :class="!(userIsAdmin || user.id_hexa === item.usuario_id) ? 'cursor-block' : ''"
            :disabled="!(userIsAdmin || user.id_hexa === item.usuario_id)"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`normas-tecnicas/edit/${item.id}`)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="userIsAdmin || user.id_hexa === item.usuario_id"
                id="action-more-normas-tecnicas"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="openDialogDelete(item.id, item.nome)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Deletar</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </base-material-card>

    <dialog-delete
      :showDialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Normas Técnicas #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>
  </v-container>
</template>

<script>
  import NormasTecnicasService from '@/services/parametrosComCa/NormasTecnicasService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';

  export default {
    name: 'CadernosServicosDataTable',

    components: {
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue')
    },

    mixins: [powerupsActionsMixins],

    props: {
      items: {
        type: Array,
        required: true
      },
      loadingItems: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        powerupService: NormasTecnicasService,
        powerupEntityName: 'Normas Técnicas',
        search: '',
        headers: [
          {
            text: '#',
            value: 'id'
          },
          {
            text: 'Nome',
            value: 'nome'
          },
          {
            text: 'Usuário',
            value: 'usuario'
          },
          {
            text: 'Criado Em',
            value: 'created'
          },
          {
            text: 'Atualizado Em',
            value: 'modified'
          },
          {
            sortable: false,
            text: 'Ações',
            value: 'actions',
            class: 'pl-4'
          }
        ]
      };
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .normas-tecnicas-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .normas-tecnicas-table table tr td:nth-child(4),
    .normas-tecnicas-table table tr td:nth-child(5) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-normas-tecnicas {
      width: 185.4px !important;
    }
  }
</style>